/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { GetCrItemsParams } from '../model/getCrItemsParams';
import type { GetCrItemsResponse } from '../model/getCrItemsResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of CrSubItems
 */
export const useGetCrItemsHook = () => {
  const getCrItems = useCustomClient<GetCrItemsResponse>();

  return (
    params?: GetCrItemsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getCrItems(
      { url: `/api/js/search/cr_items`, method: 'GET', params },
      options
    );
  };
};

export const getGetCrItemsQueryKey = (params?: GetCrItemsParams) => {
  return [`/api/js/search/cr_items`, ...(params ? [params] : [])] as const;
};

export const useGetCrItemsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    GetCrItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        QueryKey,
        GetCrItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCrItemsQueryKey(params);

  const getCrItems = useGetCrItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    QueryKey,
    GetCrItemsParams['page']
  > = ({ pageParam }) =>
    getCrItems(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    QueryKey,
    GetCrItemsParams['page']
  > & { queryKey: QueryKey };
};

export type GetCrItemsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
>;
export type GetCrItemsInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CrSubItems
 */
export const useGetCrItemsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    GetCrItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        QueryKey,
        GetCrItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCrItemsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCrItemsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCrItemsQueryKey(params);

  const getCrItems = useGetCrItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
  > = () => getCrItems(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCrItemsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
>;
export type GetCrItemsQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CrSubItems
 */
export const useGetCrItems = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCrItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCrItemsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCrItemsQueryKey(params);

  const getCrItems = useGetCrItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
  > = () => getCrItems(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCrItemsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
>;
export type GetCrItemsSuspenseQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CrSubItems
 */
export const useGetCrItemsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCrItemsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCrItemsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    GetCrItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        QueryKey,
        GetCrItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCrItemsQueryKey(params);

  const getCrItems = useGetCrItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    QueryKey,
    GetCrItemsParams['page']
  > = ({ pageParam }) =>
    getCrItems(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    ...queryOptions,
  } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    QueryKey,
    GetCrItemsParams['page']
  > & { queryKey: QueryKey };
};

export type GetCrItemsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>
>;
export type GetCrItemsSuspenseInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CrSubItems
 */
export const useGetCrItemsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
    GetCrItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCrItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCrItemsHook>>>,
        QueryKey,
        GetCrItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCrItemsSuspenseInfiniteQueryOptions(
    params,
    options
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
